import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import withComponentAuth from '../../hoc/withComponentAuth';
import { SmartFilter } from '../../components/common/SmartFilter';
import { headerPaymentTable } from '../../utils/constants';
import Pagination from '../../components/atoms/Pagination';
import { GETBookings } from '../../services/booking';
import { IBooking } from '../../utils/entities/interface';
import { debounce } from '../../utils/helper';
import { PaymentsList } from '../../components/ui/list/Payments';
import { useUrlSearchQuery } from '../../hooks/useUrlSearchQuery';

const PAYMENT_PENDING_STATUS = 'PAYMENT_PENDING';

const PaymentComp = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [bookings, setBookings] = useState<IBooking[]>([]);
  const [totalbooking, setTotalBookings] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState<string | undefined>('');

  useUrlSearchQuery((query) => {
    setSearchQuery(query);
    setPage(1);
  });

  const fetchBookings = async (
    currentPage: number,
    limit: number,
    currentSearchQuery?: string,
  ) => {
    try {
      setIsLoading(true);
      const response = await GETBookings({
        page: currentPage,
        limit,
        searchQuery: currentSearchQuery,
        status: PAYMENT_PENDING_STATUS,
      });
      setBookings(response?.data || []);
      setTotalBookings(response?.count || 0);
    } catch (error) {
      console.error('Failed to fetch bookings:', error);
      setBookings([]);
      setTotalBookings(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSearchRefresh = debounce((search: string) => {
    setSearchQuery(search);
    setPage(1);
  }, 500);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <SmartFilter
        title="Payments"
        createFilter={['SEARCH']}
        onSearch={handleSearchRefresh}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          p: 1,
        }}
      >
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          {bookings.length <= 0 && !isLoading ? (
            <Typography textAlign="center" marginTop="20%" color="#8A8D91">
              No Pending Payments Found
            </Typography>
          ) : (
            <PaymentsList
              Bookings={bookings}
              isLoading={isLoading}
              headerCells={headerPaymentTable}
            />
          )}
        </Box>

        <Box display="block">
          <Pagination
            count={totalbooking}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default withComponentAuth(PaymentComp);
